import { render, staticRenderFns } from "./StateProvinceField.vue?vue&type=template&id=5fbecebd&"
import script from "./StateProvinceField.vue?vue&type=script&lang=js&"
export * from "./StateProvinceField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports